<template>
    <div class="flex-no-wrap mt-3">
        <div v-if="nextSteps && nextSteps[0] && nextSteps[0].title" class="flex flex-row w-full">
            <div class="flex flex-col py-1 ">

                <div class="flex whitespace-nowrap" :class="{ ' scale-75': mini }">
                    <button title="Show where this needs to be done." v-if="typeof nextSteps[0].show == 'function'"
                        type="button"
                        class="button py-2 bg-yellow-500 is-small rounded-md border-black hover:bg-green-300  px-2"
                        @click.prevent="nextSteps[0].show(this, row)">
                        <i class="fas fa-fast-forward pr-1"></i>
                        <strong>
                            {{ __('labels.action_steps.' + nextSteps[0].title + ".title") }}
                        </strong>
                    </button>
                </div>
                <span :class="{ 'text-sm': mini }">
                    {{ __('labels.action_steps.' + nextSteps[0].title + ".info") }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { useKooiNavigation } from '../../pinia/KooiNavigation';
import { useActionStore } from '@/pinia/ActionStore';
export default {
    props: {
        data: {
            type: Array,
            default: [],
        },
        mini: {
            type: Boolean,
            default: false
        },
        row: {

        }
    },
    setup() {
        const kooiNavigation = useKooiNavigation();
        const actionStore = useActionStore();
        return {
            kooiNavigation,
            actionStore,
        };
    },
    data() {
        return {

        }
    },
    computed: {
        nextSteps() {
            let steps = [];
            if (!this.data || this.data.length == 0) {
                // steps = this.$store.state.kooi.kooi.action_step;
            } else {
                steps = this.data;
            }
            if (steps && steps.length > 0) {

                return this.actionStore.actions.filter((item) => {
                    return steps.includes(item.key)
                });
            }
            return [];
        },
    },
    methods: {

    }
}
</script>